import gql from 'graphql-tag';

export default gql`
  mutation ScanBarcode($ean: String!) {
    dailyTracker {
      fetchProductByEan(ean: $ean) {
        __typename
        ... on AnalyzedDailyTrackerIngredients {
          primaryIngredient {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
            measurement {
              measureId
              amount
              unit
              text
            }
            measures {
              measureId
              unit
              amount {
                value
                unit
              }
            }
          }
          requestId
        }
        ... on NotFoodError {
          message
          description
        }
        ... on ProductNotFoundError {
          productNotFoundMessage: message
          productNotFoundDescription: description
        }
        ... on AiAccessDenied {
          accessDeniedMessage: message
          accessDeniedDescription: description
        }
        ... on RateLimitExceeded {
          rateLimitExceededMessage: message
          rateLimitExceededDescription: description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
